import React from 'react';
import './BestSellers.scss';

const BestSellers = () => {
  return (
    <div>BestSellers</div>
  )
}

export default BestSellers